// extracted by mini-css-extract-plugin
export default {"rating":"HJ-z","numberOfStars":"IJ-z","count":"JJ-z","barGraphSpacing":"KJ-z","barGraph":"LJ-z"};